import { Card } from './Card';

export class CardGroup {
    constructor() {
        this.cards = [];

        this.cards = [...document.querySelectorAll('.card')]
            .map((element, index) =>
                new Card(element, index, this.select.bind(this))
            );
    }

    select(id) {
        const openID = (id === this.selectedID) ? null : id;
        for (var i = 0; i < this.cards.length; i++) {
            this.cards[i][(i === openID) ? 'show' : 'collapse']();
        }
        this.selectedID = openID;
    }
}